export const ARABIC_TRANSLATION = [
  { letter: "alif_final", symbol: "ـا" },
  { letter: "alif_isolated", symbol: "ا" },
  { letter: "ayn_final", symbol: "ـع" },
  { letter: "ayn_initial", symbol: "عـ" },
  { letter: "ayn_isolated", symbol: "ع" },
  { letter: "ayn_medial", symbol: "ـعـ" },
  { letter: "baa_initial", symbol: "بـ" },
  { letter: "baa_isolated", symbol: "ب" },
  { letter: "daad_initial", symbol: "ضـ" },
  { letter: "daad_isolated", symbol: "ض" },
  { letter: "daal", symbol: "د" },
  { letter: "dhaa", symbol: "ظ" },
  { letter: "dhaal", symbol: "ذ" },
  { letter: "faa", symbol: "ف" },
  { letter: "ghayn_final", symbol: "ـغ" },
  { letter: "ghayn_initial", symbol: "غـ" },
  { letter: "ghayn_isolated", symbol: "غ" },
  { letter: "ghayn_medial", symbol: "ـغـ" },
  { letter: "haa_final", symbol: "ـه" },
  { letter: "haa_initial", symbol: "هـ" },
  { letter: "haa_isolated", symbol: "ه" },
  { letter: "haa_medial", symbol: "ه" },
  { letter: "hhaa_initial", symbol: "حـ" },
  { letter: "jiim_initial", symbol: "جـ" },
  { letter: "jiim_isolated", symbol: "ج" },
  { letter: "kaaf_final", symbol: "ـك" },
  { letter: "kaaf_initial", symbol: "كـ" },
  { letter: "kaaf_medial", symbol: "ـكـ"},
  { letter: "khaa_initial", symbol: "خـ" },
  { letter: "khaa_isolated", symbol: "خ" },
  { letter: "laam_final", symbol: "ل" },
  { letter: "laam_initial", symbol: "لـ" },
  { letter: "miim_final", symbol: "مـ" },
  { letter: "miim_initial", symbol: "مـ" },
  { letter: "miim_isolated", symbol: "م" },
  { letter: "miim_medial", symbol: "مـ" },
  { letter: "nuun_initial", symbol: "نـ" },
  { letter: "nuun_isolated", symbol: "ن" },
  { letter: "qaaf_initial", symbol: "ق" },
  { letter: "raa", symbol: "ر" },
  { letter: "saad_initial", symbol: "صـ" },
  { letter: "saad_isolated", symbol: "ص" },
  { letter: "shiin_initial", symbol: "شـ" },
  { letter: "siin_initial", symbol: "سـ" },
  { letter: "siin_isolated", symbol: "س" },
  { letter: "taa_initial", symbol: "تـ" },
  { letter: "taa_isolated", symbol: "ت" },
  { letter: "thaa_initial", symbol: "ثـ" },
  { letter: "thaa_isolated", symbol: "ث" },
  { letter: "ttaa", symbol: "طـ" },
  { letter: "waaw", symbol: "و" },
  { letter: "yaa_initial", symbol: "يـ" },
  { letter: "yaa_isolated", symbol: "ي" },
  { letter: "zaay", symbol: "ز" },
];
